









































import axios from 'axios'
import Event, { IEvent } from '@/models/Event'
import { apiV1AdminEventPath, apiV1AdminEventsPath } from '@/rails/routes'
import { Component } from 'vue-property-decorator'
import { DataTableHeader } from 'vuetify'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import ListCount from '@/components/admin/ListCount.vue'

@Component({
  components: {
    ListCount
  }
})
export default class EventIndex extends PageBase {
  headers: Array<DataTableHeader> = [
    { text: '', value: 'actions', sortable: false, width: 80 },
    { text: 'イベント名', value: 'title', width: 200 },
    { text: '内容', value: 'description', width: 200 },
    { text: '日時', value: 'dateNumber', width: 100 }
  ]
  events: Array<Event> = []
  keyword = ''

  get filtered(): Array<Event> {
    if (this.keyword) {
      return this.events.filter(
        event => {
          return event.title.toLocaleLowerCase().includes(this.keyword.toLocaleLowerCase()) ||
            event.description.toLocaleLowerCase().includes(this.keyword.toLocaleLowerCase())
        }
      )
    }
    return this.events
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'イベント一覧'
      }
    ]
  }

  mounted(): void {
    super.mounted()
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const events = await axios.get<Array<IEvent>>(apiV1AdminEventsPath())
      this.events = events.data.map(m => new Event(m))
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  async changeStatus(event: Event): Promise<void> {
    try {
      await axios.put(apiV1AdminEventPath(event.id), {
        event: event.toParams()
      })
      this.showMessage('変更を保存しました。')
    } catch (e) {
      console.log(e)
    }
  }
}
